import {LavoratoreRecord} from "@commons/mapping/LavoratoreRecord";
import React, {useEffect, useState} from "react";
import {DettaglioRetribuzioneRecord} from "@commons/mapping/DettaglioRetribuzioneRecord";
import {LavoratoreRML, LavoratoreSingoloElementoRML, NomeCampiTotalizzabili} from "@commons/mapping/LavoratoreRML";
import InputEx from "../../../../components/wrapperComponents/InputEx";
import {formatDt, pagaOrariaFormat, percentualFormat} from "@commons/utils/util";
import LegendaRML from "../../../azienda/tabelle/LegendaRML";
import BasicBadge, {badgeStyle} from "../../../../components/BasicBadge";
import Toggle from "../../../../components/Toggle";
import {formatImporto} from "../../Lavoratori.retrib.page";
import {TooltipEx} from "../../../../components/Tooltip";
import FormButtons from "../../../../components/FormButtons";
import classes from './DettaglioRetribuzione.module.css';
import clsx from "clsx";
import {IconArrowNarrowDown, IconArrowNarrowUp} from "@tabler/icons-react";

interface ShowImportoProps {
    showArrow: boolean,
    elemento: number | null,
    elementoPrec: number | null,
    children: React.ReactNode,
}

const ShowImporto: React.FC<ShowImportoProps> = ({
                                                     showArrow,
                                                     elemento,
                                                     elementoPrec,
                                                     children
                                                 }) => {
    if (showArrow && elemento && elementoPrec) {
        const diff = elemento - elementoPrec;
        if (diff > 0)
            return <TooltipEx tooltip={`L'importo è aumentato di ${formatImporto(diff)}.`}><p className="inline-flex text-blue-500"><IconArrowNarrowUp
                className={clsx('h-5 w-5', classes.glowingReviewUp)}/>{children}
            </p>
            </TooltipEx>;
        else if (diff < 0)
            return <TooltipEx tooltip={`L'importo è diminuito di ${formatImporto(diff)}.`}><p className="inline-flex text-red-600"><IconArrowNarrowDown
                className={clsx('h-5 w-5', classes.glowingReviewDwn)}/>{children}
            </p>
            </TooltipEx>;
        else
            return <>{children}</>;
    } else
        return <>{children}</>;
}

interface DettaglioRetribuzioneProps {
    dettagliContratto: LavoratoreRecord | null | undefined,
    dettagliRetribuzione: DettaglioRetribuzioneRecord | null,
    mostraRetribOraria: boolean,
    toggleRetribOraria: (v: boolean) => void,
    onCancel: () => void,
    mostraNominativo?: boolean,
}

export const DettaglioRetribuzione: React.FC<DettaglioRetribuzioneProps> = ({
                                                                                dettagliContratto,
                                                                                dettagliRetribuzione,
                                                                                mostraRetribOraria,
                                                                                toggleRetribOraria,
                                                                                onCancel,
                                                                                mostraNominativo,
                                                                            }) => {
    const [retribNonAdeguata, setRetribNonAdeguata] = useState<boolean>(true);
    const [mesePrec, setMesePrec] = useState<boolean>(false);

    useEffect(() => {
        setMesePrec(false);
    }, [dettagliRetribuzione])

    const classeElementiRetributivi = `border 
                            md:basis-1/2 
                            md:max-w-[50%] 
                            lg:basis-[11.1111111%] 
                            lg:max-w-[11.1111111%]
                            p-1 
                            h-14`;
    const nomeRetribuzione: NomeCampiTotalizzabili = mostraRetribOraria || retribNonAdeguata ? 'retribuzioneNonAdeguata' : 'retribuzioneCompenso';
    const conTabella = dettagliRetribuzione && dettagliRetribuzione.codTabella ? true : false;
    const getBgColor = (elemento: LavoratoreSingoloElementoRML, index: number) => badgeStyle[conTabella ? DettaglioRetribuzioneRecord.getType(index + 1) : DettaglioRetribuzioneRecord.getInfoType(elemento.tipo)].bg;
    const elementi = dettagliRetribuzione ? (mesePrec ? dettagliRetribuzione.elementiPrec : dettagliRetribuzione.elementi) : [];
    const pagaOraria = elementi.length > 0 ? elementi[0].pagaOraria : false; // La retribuzione del lavoratore e' espressa come paga oraria
    const divisoreOrario = elementi.length > 0 ? elementi[0].divisoreOrario : 0;
    const valorizzaTotale = (elementi: LavoratoreSingoloElementoRML[], nomeRetribuzione: NomeCampiTotalizzabili) => {
        if (mostraRetribOraria) {
            if (pagaOraria) {
                return DettaglioRetribuzioneRecord.totaleElementi(elementi, 'retribuzioneNonAdeguata');
            } else {
                if (divisoreOrario) {
                    return DettaglioRetribuzioneRecord.totaleElementi(elementi, 'retribuzioneNonAdeguata') / divisoreOrario;
                }
            }
            return null;
        } else
            return DettaglioRetribuzioneRecord.totaleElementi(elementi, nomeRetribuzione);
    }
    const decorrenza = dettagliRetribuzione ? dettagliRetribuzione.elementi[0].decorrenza : null;
    const kPagaOraria = (pagaOraria ? divisoreOrario : 1);
    const kPartTime = dettagliRetribuzione ? ((dettagliRetribuzione.percentualePT === 100 || retribNonAdeguata) ? 1 : (dettagliRetribuzione.percentualePT / 100.0)) : 1;
    const RAL = dettagliRetribuzione ? dettagliRetribuzione.numMensilita * (DettaglioRetribuzioneRecord.totaleElementi(elementi, 'retribuzioneNonAdeguata') * kPagaOraria) * kPartTime : 0;
    return <>
        {dettagliContratto && dettagliRetribuzione &&
            <>
                <div className="p-3">
                    <div className="flexRowWrap">
                        {/*<div className="w-full py-1 text-xs font-thin">
                            {dettagliRetribuzione.URI}
                        </div>*/}
                        <div className="w-full py-1">
                            Inquadramento ed elementi retributivi
                            {mostraNominativo && <> di <span className="font-medium">{DettaglioRetribuzioneRecord.getDescrizioneLavoratore(dettagliRetribuzione)}</span></>}
                            &nbsp;al&nbsp;
                            <BasicBadge containerClass="text-sm" label={formatDt(decorrenza, 'LLLL yyyy')}
                                        type={"custom"}
                                //customStyle={{bg: "bg-red-100", text: "text‑inherit"}}/>
                                        customStyle={{bg: "bg-red-100", text: "text‑current"}}/>
                        </div>
                    </div>
                    <div className="flexRowWrap">
                        <div className="sm1-4P">
                            <InputEx
                                label="Data ass. convenzionale"
                                name="dataAssConvenzionale"
                                value={formatDt(dettagliContratto.dataAssConvenzionale)}
                                readOnly/>
                        </div>
                        <div className="sm1-4P">
                            <InputEx
                                label="Data assunzione"
                                name="dataAssunzione"
                                value={formatDt(dettagliContratto.dataAssunzione)}
                                readOnly
                            />
                        </div>
                        <div className="sm1-4P">
                            <InputEx
                                label="Data fine T.Det."
                                name="dataFineTDET"
                                value={formatDt(dettagliContratto.dataFineTDET)}
                                readOnly
                            />
                        </div>
                        <div className="sm1-4P">
                            <InputEx
                                label="Data fine rapporto"
                                name="dataCessazione"
                                value={formatDt(dettagliContratto.dataCessazione)}
                                readOnly
                            />
                        </div>
                    </div>
                    {/*Date di assunzione, cessazione, etc.*/}
                    <div className="flexRowWrap">
                        <div className="sm1-4P">
                            <InputEx
                                label="Settore CCNL"
                                name="settoreCCNL"
                                value={dettagliRetribuzione.settoreCCNL}
                                readOnly/>
                        </div>
                        <div className="sm1-4P">
                            <InputEx
                                label="Contratto CCNL"
                                name="descrizioneContratto"
                                value={DettaglioRetribuzioneRecord.getDescrizioneContratto(dettagliRetribuzione)}
                                readOnly/>
                        </div>
                        <div className="sm1-4P">
                            <InputEx
                                label="Livello"
                                name="codLivello"
                                value={dettagliRetribuzione.codLivello}
                                readOnly/>
                        </div>
                        <div className="sm1-4P">
                            <InputEx
                                label="RAL"
                                name="importoRAL"
                                value={formatImporto(RAL)}
                                readOnly/>
                        </div>

                    </div>
                    <div className="flexRowWrap">
                        <div className="sm1-4P">
                            <InputEx
                                label="Qualifica"
                                name="descrizioneQualifica"
                                value={dettagliRetribuzione.descrizioneQualifica}
                                readOnly/>
                        </div>
                        <div className="sm1-4P">
                            <InputEx
                                label="% Part-Time"
                                name="percPartTime"
                                value={dettagliRetribuzione.percentualePT === 100 ? '-' : formatImporto(dettagliRetribuzione.percentualePT / 100.0, percentualFormat, '-')}
                                readOnly/>
                        </div>
                        <div className="sm1-4P">
                            <InputEx
                                label="Cod. lavoratore"
                                name="codDip"
                                value={dettagliRetribuzione.codDip}
                                readOnly/>
                        </div>
                        <div className="sm1-4P">
                            <InputEx
                                label="Cod. lav. paghe"
                                name="codDipPaghe"
                                value={dettagliRetribuzione.codDipPaghe}
                                readOnly/>
                        </div>
                    </div>
                    <div className="flexRowWrap mt-3">
                        <div className="w-full flex flex-row justify-start gap-4">
                            <div className="mr-auto self-center">
                                Tabella:&nbsp;<span
                                className={conTabella ? "" : "text-red-600"}>{conTabella ? dettagliRetribuzione.descrizioneTabella + ' [#' + dettagliRetribuzione.codTabella + ']' : 'Nessuna tabella!'}</span>
                                {pagaOraria && <span className="mx-2 text-red-500 font-medium">Retrib. oraria</span>}
                            </div>
                            <div className="w-48">
                                {!pagaOraria &&
                                    <Toggle auxState={mostraRetribOraria} onChange={(v) => toggleRetribOraria(v)}
                                            label={mostraRetribOraria ? 'Retrib. oraria' : 'Retrib. mensile'}/>}
                            </div>
                            <div className="w-64">
                                <Toggle auxState={retribNonAdeguata} onChange={(v) => setRetribNonAdeguata(v)}
                                        label={retribNonAdeguata ? 'Retrib. intera' : 'Retrib. adeguata al part-time'}/>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col flex-wrap md:flex-row mt-3 lg:text-xs xl:text-base">
                        {elementi.map((elemento, index) => {
                            return <div key={index}
                                        className={`${classeElementiRetributivi} ${elemento.elementoDiscrezionale ? 'border-red-600' : 'border-gray-300'} ${getBgColor(elemento, index)}`}>
                                <>
                                    {elemento.idDip > 0 &&
                                        <div className="h-full flex flex-col justify-between">
                                            <div>
                                                <TooltipEx tooltip={<div><p className="font-medium">{elemento.descrizioneElemento}</p><p>{elemento.noteElemento}</p></div>}>
                                                    <div className="text-ellipsis overflow-hidden whitespace-nowrap">{elemento.descrizioneElemento}</div>
                                                </TooltipEx>
                                            </div>
                                            <div className="text-right font-semibold">
                                                <ShowImporto elemento={elemento.retribuzioneNonAdeguata}
                                                             elementoPrec={dettagliRetribuzione.elementiPrec[index].retribuzioneNonAdeguata}
                                                             showArrow={elementi === dettagliRetribuzione.elementi}>
                                                    {formatImporto(LavoratoreRML.valorizzaElemento((pagaOraria || mostraRetribOraria), nomeRetribuzione, elemento), (pagaOraria || mostraRetribOraria) ? pagaOrariaFormat : undefined)}
                                                </ShowImporto>
                                            </div>
                                        </div>} {/*ELEMENTO VALORIZZATO!*/}

                                    {elemento.idDip === 0 &&
                                        <span className="text-xs font-thin">{DettaglioRetribuzioneRecord.getGroupIndex(index + 1)}</span>} {/*Elemento NULLO!*/}
                                </>
                            </div>
                        })
                        }
                        <div className={classeElementiRetributivi + ' border-gray-300'}>
                            <div className="h-full flex flex-col justify-between">
                                <div>
                                    <TooltipEx tooltip="Totale retribuzione">
                                        <div className="text-ellipsis overflow-hidden whitespace-nowrap">Totale retribuzione</div>
                                    </TooltipEx>
                                </div>
                                <div className="text-right font-semibold">
                                    <ShowImporto elemento={valorizzaTotale(elementi, nomeRetribuzione)}
                                                 elementoPrec={valorizzaTotale(dettagliRetribuzione.elementiPrec, nomeRetribuzione)}
                                                 showArrow={elementi === dettagliRetribuzione.elementi}>
                                        {formatImporto(valorizzaTotale(elementi, nomeRetribuzione), (pagaOraria || mostraRetribOraria) ? pagaOrariaFormat : undefined)}
                                    </ShowImporto>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-3 w-full flex flex-row justify-end">
                        <div className="w-48">
                            <Toggle auxState={mesePrec} onChange={(v) => setMesePrec(v)}
                                    label='Mese precedente'/>
                        </div>
                    </div>
                </div>
                <LegendaRML discrezionale/>
                <FormButtons onCancel={onCancel} resource={dettagliRetribuzione} readonly/>
            </>
        }
    </>
}
export default DettaglioRetribuzione;